import React from "react";

export const StatsSection = () => {
  return (
    <section className="w-full bg-white py-12">
      <div className="max-w-7xl mx-auto px-6 space-y-10">

        <div className=" grid grid-cols-1 md:grid-cols-2 gap-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">A decade of <br/>industrial work</h2>
          <p>We've spent over ten years learning what works in the field. Our team has completed more than fifty projects across textile mills, food processing plants, and manufacturing facilities. We know the work because we've done it.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Item 1 */}
          <div className="flex gap-4 items-start">
            <span className="w-1 bg-orange-500 h-full"></span>
            <div className=" space-y-6">
              <h3 className="text-lg font-semibold text-gray-900">Years of Experience</h3>
              <h2 className="text-4xl font-bold text-gray-900">10+</h2>
              <p className="mt-2 text-sm text-gray-600 max-w-xs">
                Building industrial systems since our founding
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex gap-4 items-start">
            <span className="w-1 bg-orange-500 h-full"></span>
            <div className=" space-y-6">
              <h3 className="text-lg font-semibold text-gray-900">Projects completed</h3>
              <h2 className="text-4xl font-bold text-gray-900">50+</h2>
              <p className="mt-2 text-sm text-gray-600 max-w-xs">
                Boiler erection, pipelines, fabrication, and more
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex gap-4 items-start">
            <span className="w-1 bg-orange-500 h-full"></span>
            <div className=" space-y-6">
              <h3 className="text-lg font-semibold text-gray-900">Technical team members</h3>
              <h2 className="text-4xl font-bold text-gray-900">20+</h2>
              <p className="mt-2 text-sm text-gray-600 max-w-xs">
                Skilled engineers and welders on every job
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};